export default __webpack_public_path__ + "static/showcase-brand-identity-design-work@2x-d05b7bc81e6a921e317433eff454b63a.png";